export enum OnboardingStep {
  CREATE = "CREATE",
  OFFER = "OFFER",
  INFORMATION = "INFORMATION",
  LEADER = "LEADER",
  UBO = "UBO",
  STRIPE = "STRIPE",
  PACKAGE = "PACKAGE",
  LEGAL_PLACE = "LEGAL_PLACE",
  CONTRACT = "CONTRACT",
  GET_ID = "GET_ID",
  FINISH = "FINISH",
}
